import theme from '@themes/theme';

// ── TA-9682 layout budget constants ──────────────────────────────────────────
export const IMAGE_GRID_WIDTH_RATIO = 0.72;
export const IMAGE_GRID_MAX_WIDTH_WEB = 470;
export const IMAGE_GRID_RECEIVED_OFFSET = 20;
export const IMAGE_GRID_MIN_WIDTH = 200;
export const IMAGE_GRID_FALLBACK_WIDTH = 298;

const BUBBLE_HORIZONTAL_PADDING = theme.spacing.xxs * 2;
const CHAT_BUBBLE_SENDER_OFFSET = 120;
const CHAT_BUBBLE_RECEIVER_OFFSET = 92;

/**
 * Computes the maxWidth to pass to ChatImageGrid (web only).
 *
 * Formula (TA-9682):
 *   base = min(floor(chatDrawerWidth × 0.72), 470px)
 *   budgetWithOffset = received ? base + 20 : base   // +20 for missing check icon
 *   clampedToBubble = min(budgetWithOffset, bubbleMaxWidth)
 *   result = max(clampedToBubble − bubblePadding, 200)
 */
export function computeImageGridMaxWidth(
  chatDrawerWidth: number,
  isSender: boolean,
  hasBody: boolean
): number {
  if (chatDrawerWidth <= 0) return IMAGE_GRID_FALLBACK_WIDTH;
  const base = Math.min(
    Math.floor(chatDrawerWidth * IMAGE_GRID_WIDTH_RATIO),
    IMAGE_GRID_MAX_WIDTH_WEB
  );
  const budgetWithOffset = !isSender ? base + IMAGE_GRID_RECEIVED_OFFSET : base;
  const bubbleMaxWidth =
    hasBody && isSender
      ? chatDrawerWidth - CHAT_BUBBLE_SENDER_OFFSET
      : chatDrawerWidth - CHAT_BUBBLE_RECEIVER_OFFSET;
  return Math.max(
    Math.min(budgetWithOffset, bubbleMaxWidth) - BUBBLE_HORIZONTAL_PADDING,
    IMAGE_GRID_MIN_WIDTH
  );
}
